import {TarificationState} from "@/store/tarification/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: TarificationState = {
  tariffZone: undefined,
  tariffZoneGroup: undefined,
  tariffZones: [],
  tariffs: [],
  tariff: undefined
}

export const tarification: Module<TarificationState, RootState> = {
  state,
  getters,
  actions,
  mutations
}